import { Flex, Image, Box, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Modal from "src/components/Modal";
import { H3, BodyText2, Subtitle2 } from "src/atoms/typography";
import getImageSrc from "src/utils/getImageSrc";

export default function BabyStoppedDialog({
  isOpen,
  onDismiss,
  deviceName,
  avatarName,
  stoppedByButton
}) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen}>
      {deviceName && (
        <Box
          bg="primary"
          p="8px"
          borderTopLeftRadius="12px"
          borderTopRightRadius="12px"
        >
          <Subtitle2
            color="white"
            textAlign="center"
            overflowX="hidden"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
          >
            {deviceName}
            {avatarName && ` - ${avatarName}`}
          </Subtitle2>
        </Box>
      )}
      <Flex
        width="280px"
        pt="24px"
        pb="8px"
        px="32px"
        flexDirection="column"
        alignItems="center"
      >
        <Image src={getImageSrc("monitoring-stopped.svg")} />
        <H3 mt="16px" color="highEmphasis" textAlign="center">
          {t("parentStation.babyStoppedDialog.heading")}
        </H3>
        <BodyText2 mt="8px" color="mediumEmphasis" textAlign="center">
          {t(
            stoppedByButton
              ? "parentStation.babyStoppedDialog.text"
              : "parentStation.scheduledMonitoringStopped.text"
          )}
        </BodyText2>

        <Button
          variant="flatPrimary"
          minWidth="158px"
          mt="8px"
          onClick={onDismiss}
        >
          {t("buttons.ok")}
        </Button>
      </Flex>
    </Modal>
  );
}
